module.exports = __webpack_public_path__ + "img/banner14.599c1857.jpg";